import request from "./client";

export const triggerArticleImport = async ({ updateExisting = false } = {}) => {
  try {
    const resp = await request
      .post("/v1/erp/sqlbase/articles/import")
      .query({ update_existing: updateExisting });
    return { data: resp.body, error: null };
  } catch (e) {
    if (!e.response) return { data: null, error: e };
    return { data: null, error: e.response.body, status: e.response.status };
  }
};

export const getArticleImportStatus = async () => {
  try {
    const resp = await request.get("/v1/erp/sqlbase/articles/import/status");
    return { data: resp.body, error: null };
  } catch (e) {
    if (!e.response) return { data: null, error: e };
    return { data: null, error: e.response.body };
  }
};
